// 常量js
// var serviceUrl = "http://192.168.31.102:8443";
// var webUrl = "http://192.168.31.102:8080";
var serviceUrl = "http://vote.89892528.com:8443";
var webUrl = "http://vote.89892528.com:8080";


var menuData =[
    {
        "id": 1,
        "path": "/admin",
        "name": "AdminIndex",
        "nameZh": "投票管理",
        "iconCls": "el-icon-tickets",
        "component": "AdminIndex",
        "parentId": 0,
        "children": [
            {
                "id": 2,
                "path": "/admin/vote/list",
                "name": "ListActivity",
                "nameZh": "活动列表",
                "iconCls": null,
                "component": "vote/ListActivity",
                "parentId": 1,
                "children": []
            },
            {
                "id": 17,
                "path": "/admin/vote/add/index",
                "name": "CreateActivity",
                "nameZh": "创建活动",
                "iconCls": null,
                "component": "vote/AddActivity",
                "parentId": 1,
                "children": [
                    {
                        "id": 21,
                        "path": "/admin/vote/add/item",
                        "name": "CreateItem",
                        "nameZh": "选项设置",
                        "iconCls": "",
                        "component": "vote/VoteItem",
                        "parentId": 17,
                        "children": []
                    },
                    {
                        "id": 22,
                        "path": "/admin/vote/add/setting",
                        "name": "VoteSetting",
                        "nameZh": "活动设置",
                        "iconCls": null,
                        "component": "vote/VoteEdit",
                        "parentId": 17,
                        "children": []
                    },
                    {
                        "id": 23,
                        "path": "/admin/vote/add/index",
                        "name": "addIndex",
                        "nameZh": "活动创建",
                        "iconCls": "",
                        "component": "vote/Create",
                        "parentId": 17,
                        "children": []
                    },
                    {
                        "id": 24,
                        "path": "/admin/vote/list/result",
                        "name": "VoteResult",
                        "nameZh": "投票统计",
                        "iconCls": null,
                        "component": "vote/VoteResult",
                        "parentId": 17,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "id": 3,
        "path": "/admin",
        "name": "User",
        "nameZh": "用户管理",
        "iconCls": "el-icon-user",
        "component": "AdminIndex",
        "parentId": 0,
        "children": [
            {
                "id": 6,
                "path": "/admin/user/profile",
                "name": "Profile",
                "nameZh": "用户信息",
                "iconCls": null,
                "component": "user/UserProfile",
                "parentId": 3,
                "children": []
            },
            {
                "id": 7,
                "path": "/admin/user/role",
                "name": "Role",
                "nameZh": "角色配置",
                "iconCls": null,
                "component": "user/Role",
                "parentId": 3,
                "children": []
            }
        ]
    },
    {
        "id": 4,
        "path": "/admin",
        "name": "Content",
        "nameZh": "内容管理",
        "iconCls": "el-icon-document",
        "component": "AdminIndex",
        "parentId": 0,
        "children": [
            {
                "id": 8,
                "path": "/admin/content/activity",
                "name": "ActivityManagement",
                "nameZh": "活动管理",
                "iconCls": null,
                "component": "content/ActivityManagement",
                "parentId": 4,
                "children": []
            },
            {
                "id": 9,
                "path": "/admin/content/notice",
                "name": "NoticeManagement",
                "nameZh": "公告管理",
                "iconCls": null,
                "component": "content/NoticeManagement",
                "parentId": 4,
                "children": []
            },
            {
                "id": 10,
                "path": "/admin/content/add/notice",
                "name": "CaseManagement",
                "nameZh": "添加公告",
                "iconCls": null,
                "component": "content/CaseManagement",
                "parentId": 4,
                "children": []
            }
        ]
    },
    {
        "id": 5,
        "path": "/admin",
        "name": "Account",
        "nameZh": "账号设置",
        "iconCls": "el-icon-setting",
        "component": "AdminIndex",
        "parentId": 0,
        "children": [
            {
                "id": 18,
                "path": "/admin/account/info",
                "name": "AccountInfo",
                "nameZh": "账户信息",
                "iconCls": null,
                "component": "account/UserInfo",
                "parentId": 5,
                "children": []
            }
        ]
    }
];

export {
    serviceUrl,
    webUrl,
    menuData
}



// WEBPACK FOOTER //
// ./src/utils/common/url.js